export default __webpack_public_path__ + "static/media/benefit3.757bb019.svg";